import React from 'react';
import clsx from 'clsx';
import { Form } from 'react-bootstrap';
import type { FormikErrors } from 'formik';
import Styles from './ConstructionItemSettingList.module.scss';

import { toThousandSeparator } from '~/utils/CurrencySeparator';
import type { ConstructionItem } from '~/models/ConstructionItem';
import type { ConstructionItemSettingEdit } from '~/models/ConstructionItemSetting';

type Props = {
  constructionItem: ConstructionItem;
  showUpdate: boolean;
  errors: FormikErrors<ConstructionItemSettingEdit | undefined>[];
  values: ConstructionItemSettingEdit[];
  setValues: (
    values: React.SetStateAction<ConstructionItemSettingEdit[]>
  ) => void;
};

export const ConstructionItemSettingListRow: React.FC<Props> = ({
  constructionItem,
  showUpdate,
  errors,
  values,
  setValues
}: Props) => {
  const newItemSetting = React.useMemo(
    () => values.find((v) => v.constructionItemId === constructionItem.id),
    [constructionItem.id, values]
  );
  const index = React.useMemo(
    () =>
      values.findIndex(
        (setting) => setting.constructionItemId === constructionItem.id
      ),
    [constructionItem.id, values]
  );
  const unitAmount = newItemSetting
    ? newItemSetting.unitAmount
    : constructionItem.unitAmount;
  const handleChangeItemSetting = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const newItemSettings = [...values];
    const { value } = e.target;
    const valueNum = value === '' ? null : Number(value);
    if (index === -1) {
      newItemSettings.push({
        unitAmount: valueNum,
        constructionItemId: constructionItem.id
      });
    } else {
      const itemSetting = {
        ...newItemSetting,
        unitAmount: valueNum,
        constructionItemId: constructionItem.id
      };
      newItemSettings.splice(index, 1, itemSetting);
    }
    setValues(newItemSettings);
  };
  if (errors === null) {
    return null;
  }
  return (
    <tr className={clsx(Styles.ListRow)}>
      <td className={clsx(Styles.ListCol, Styles.PcCol)}>
        <div className={Styles.ConstructionItemName}>
          {constructionItem.name}
        </div>
        <p className={Styles.DefaultAmount}>
          初期値: ¥{toThousandSeparator(constructionItem.unitAmount)}
        </p>
      </td>
      <td className={clsx(Styles.ListCol, Styles.Edit)}>
        {showUpdate && constructionItem.overridable ? (
          <>
            <Form.Control
              isInvalid={!!errors[index]}
              onChange={handleChangeItemSetting}
              placeholder="単価"
              type="number"
              value={unitAmount ?? ''}
            />
            <Form.Control.Feedback type="invalid">
              {errors[index]?.unitAmount}
            </Form.Control.Feedback>
          </>
        ) : (
          <>{unitAmount && <>¥{toThousandSeparator(unitAmount)}</>}</>
        )}
      </td>
    </tr>
  );
};
